// Consultation/ConsultationCommunicationTypesPicker.tsx
import React, {useEffect} from 'react';
import {Box, Checkbox, FormControlLabel, FormGroup, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {Controller} from 'react-hook-form';
import {AppDispatch, RootState} from "Redux/store";
import {fetchPsychologyParams} from "Redux/psychologyParamsSlice";
import {communicationTypeMapping} from "Locale/ruMap";

interface ConsultationCommunicationTypesPickerProps {
    control: any;
}

const ConsultationCommunicationTypesPicker: React.FC<ConsultationCommunicationTypesPickerProps> = ({control}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {communication_types, status} = useSelector((state: RootState) => state.psychologyParams);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchPsychologyParams());
        }
    }, [status, dispatch]);

    if (status === 'loading') {
        return <Typography>Загрузка способов связи...</Typography>;
    }

    if (status === 'failed') {
        return <Typography color="error">Ошибка загрузки способов связи</Typography>;
    }

    return (
        <Box>
            {communication_types && communication_types.length > 0 ? (
                <FormGroup row>
                    <Controller
                        name="consultation_communication_types"
                        control={control}
                        render={({field}) => (
                            <>
                                {communication_types.map((type) => (
                                    <FormControlLabel
                                        key={type.id}
                                        control={
                                            <Checkbox
                                                checked={field.value.includes(type.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        field.onChange([...field.value, type.id]);
                                                    } else {
                                                        field.onChange(field.value.filter((id: number) => id !== type.id));
                                                    }
                                                }}
                                            />
                                        }
                                        label={communicationTypeMapping[type.value]}
                                    />
                                ))}
                            </>
                        )}
                    />
                </FormGroup>
            ) : (
                <Typography>Нет доступных способов связи.</Typography>
            )}
        </Box>
    );
};

export default ConsultationCommunicationTypesPicker;
